import React from 'react';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import ApplicationMessageBox from './ApplicationMessageBox';

const YoungRestriction = () => {
  return (
    <ApplicationMessageBox>
      <Typography color="error" variant="h6" component="p">
        {T.translate('lessThan18')}
      </Typography>
    </ApplicationMessageBox>
  );
};

export default YoungRestriction;
